import styled from 'styled-components';
import { Avatar } from 'react-rainbow-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledAvatar = styled(Avatar)`
    flex-shrink: 0;
`;
